// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".precise-price-app .rebates-widget--hgRy-{font-size:16px;text-align:center}", ""]);
// Exports
exports.locals = {
	"rebatesWidget": "rebates-widget--hgRy-"
};
module.exports = exports;
